import { c as _c } from "react/compiler-runtime";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { fetchingSdbCompanyFlagsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";

/** Columns to be displayed in the projects table */
export const requiredProjectTableColumns = ["name", "projectManager", "group", "created", "lastCaptured", "lastUpdated", "client", "size", "accessLevel", "options"];

/** Columns visible by default in the projects table */
const defaultVisibleProjectTableColumns = ["name", "projectManager", "group", "created", "lastUpdated", "accessLevel"];
/**
 * Returns the project table column config for the current workspace.
 * Single-admin workspaces hide the project manager column entirely.
 */
export function useProjectTableColumnsConfig() {
  const $ = _c(7);
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const {
    fetchSelectedCompanyContext
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const isCompanyContextReady = fetchSelectedCompanyContext === "succeeded" || fetchSelectedCompanyContext === "rejected";
  if (canAssignManagers) {
    let t0;
    if ($[0] !== isCompanyContextReady) {
      t0 = {
        columns: requiredProjectTableColumns,
        defaultVisibleColumns: defaultVisibleProjectTableColumns,
        isCompanyContextReady
      };
      $[0] = isCompanyContextReady;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function isNotManagerColumn(column) {
      return column !== "projectManager";
    };
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isNotManagerColumn = t0;
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = requiredProjectTableColumns.filter(isNotManagerColumn);
    t2 = defaultVisibleProjectTableColumns.filter(isNotManagerColumn);
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isCompanyContextReady) {
    t3 = {
      columns: t1,
      defaultVisibleColumns: t2,
      isCompanyContextReady
    };
    $[5] = isCompanyContextReady;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}